import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Hijack } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class HijackService implements HttpService<Hijack> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Hijack[]>> {
        return this.http.get<Hijack[]>(env.API_URL + '/hijacks', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<Hijack>> {
        return this.http.get<Hijack>(env.API_URL + '/hijacks/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.hijack_id) {
                    resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                return resp;
            })
        );
    }

    post(t: Hijack): Observable<HttpResponse<Hijack>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    put(t: Hijack): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

}
